import * as React from "react";
import { forwardRef } from "react";
const SvgMiniPlayer = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", fill: "none", ref, ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 6H20V18H4V6ZM2 20V4H22V20H2ZM12 11H6V16H12V11Z", fill: "currentcolor" }));
const ForwardRef = forwardRef(SvgMiniPlayer);
export default ForwardRef;
